export const doCreateMessage = (
  type,
  minLength,
  maxLength,
  currentLength,
  defaultLanguage
) => {
  if (!type) return null;
  switch (type) {
    case 'min': {
      if (!minLength) return;
      const minLengthVal = minLength && minLength.value;
      const errorMessage =
        minLength && minLength.message && minLength.message[defaultLanguage];
      const minText = `Minimum of ${minLengthVal.toString()} characters`;
      if (errorMessage) {
        return errorMessage;
      } else {
        return minText;
      }
    }
    case 'max': {
      if (!maxLength) return;
      const maxLengthVal = maxLength && maxLength.value;
      const errorMessage =
        maxLength && maxLength.message && maxLength.message[defaultLanguage];
      const maxText = `Maximum of ${maxLengthVal.toString()} characters`;
      if (errorMessage) {
        return errorMessage;
      } else {
        return maxText;
      }
    }
    case 'between': {
      if (!maxLength || !minLength) return;
      const minLengthVal = minLength && minLength.value;
      const maxLengthVal = maxLength && maxLength.value;
      const errorMessage =
        minLength && minLength.message && minLength.message[defaultLanguage];
      const rangeText = `Between ${minLengthVal.toString()}-${maxLengthVal.toString()} characters)`;
      if (errorMessage) {
        return errorMessage;
      } else if (currentLength < minLengthVal) {
        return `${(minLengthVal - currentLength).toString()} character${
          minLengthVal > 1 ? 's' : ''
        } required ${rangeText}`;
      } else if (currentLength > maxLengthVal) {
        return `${(currentLength - maxLengthVal).toString()} character${
          currentLength - maxLengthVal > 1 ? 's' : ''
        } over ${rangeText}`;
      } else if (currentLength) {
        return `${(
          maxLengthVal - currentLength
        ).toString()} characters remaining ${rangeText}`;
      } else {
        return rangeText;
      }
    }
    default:
      return null;
  }
};


export const getFieldType = field => {
  if (!field) return null;
  const { dataType, dataFormat, editor, validations, id, groupId } = field || {}

  if (groupId === 'private' || groupId === 'settings') return 'hidden';
  if (editor?.properties?.readOnly && dataFormat !== 'quote') return 'hidden'; 
  if (dataFormat === 'quote') return 'content';
  if (dataFormat === 'quote' && editor?.properties?.readOnly) return 'content';

  if (dataType === 'string') {
    if (editor?.id === 'multiline') return 'textarea';
    if (editor?.id === 'list-dropdown') return 'dropdown';
    if (validations?.allowedValues) return 'radio';
    if (id === 'country') return 'country';
    return 'textfield'; // Default string type
  }

  if (dataType === 'stringArray' || dataType === 'boolean') return 'checkbox';
  if (dataType === 'integer') return 'number';
  if (dataType === 'dateTime') return 'date';
  if (dataFormat === 'daterange') return 'dateRange';
  if (dataFormat === 'entry') return 'entryPicker';
  if (groupId === 'private' || groupId === 'settings') return 'hidden';

  return 'textfield'; // Default fallback
};
